import React from 'react';
import useReactApexChart from '../../hook/useReactApexChart';
import ReactApexChart from 'react-apexcharts';

const ShipmentStatistics = ({ shipTypeTrack }) => {
    // let { statisticsDonutChartSeries, statisticsDonutChartOptions } = useReactApexChart();

    let statisticsDonutChartSeries = [
        shipTypeTrack?.airPercentage || 0,
        shipTypeTrack?.shipPercentage || 0,
    ];

    let statisticsDonutChartOptions = {
        colors: ["#FF9F29", "#243E85"],
        labels: ["AIR", "SHIP"],
        legend: {
            show: false,
        },
        chart: {
            type: "donut",
            height: 230,
            sparkline: {
                enabled: true,
            },
            margin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
        },
        stroke: {
            width: 0,
        },
        dataLabels: {
            enabled: false,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: "bottom",
                    },
                },
            },
        ],
    };

    return (
        <div className="col-xxl-3">
            <div className="card h-100 radius-8 border-0">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg">Tracking Shipment Types</h6>

                    </div>


                    {shipTypeTrack?.shipment_type_ship !== 0 && shipTypeTrack?.shipment_type_air !== 0 ?

                    <>
                    <div className="position-relative">
                        <span className="w-80-px h-80-px bg-base shadow text-primary-light fw-semibold text-xl d-flex justify-content-center align-items-center rounded-circle position-absolute end-0 top-0 z-1">
                            {shipTypeTrack?.airPercentage.toFixed() ||  0}%
                        </span>

                        <ReactApexChart options={statisticsDonutChartOptions} series={statisticsDonutChartSeries} type="donut" height={230} id="statisticsDonutChart"
                            className="mt-36 flex-grow-1 apexcharts-tooltip-z-none title-style circle-none" />
                        <span className="w-80-px h-80-px bg-base shadow text-primary-light fw-semibold text-xl d-flex justify-content-center align-items-center rounded-circle position-absolute start-0 bottom-0 z-1">
                            { shipTypeTrack?.shipPercentage.toFixed() || 0}%

                        </span>
                    </div>
                    <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
                        <li className="d-flex align-items-center gap-2">
                            <span className="w-12-px h-12-px radius-2 bg-primary-600" />
                            <span className="text-secondary-light text-sm fw-normal">
                                SHIP:
                                <span className="text-primary-light fw-bold">{shipTypeTrack?.shipment_type_ship || 0}</span>
                            </span>
                        </li>
                        <li className="d-flex align-items-center gap-2">
                            <span className="w-12-px h-12-px radius-2 bg-yellow" />
                            <span className="text-secondary-light text-sm fw-normal">
                                AIR:
                                <span className="text-primary-light fw-bold">{shipTypeTrack?.shipment_type_air || 0}</span>
                            </span>
                        </li>
                    </ul>
                    </> : (

                        <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"100%"}}>

                            <p>Nothing to show</p>
                            </div>
                    )
                    
                    }
                </div>
            </div>
        </div>
    );
};

export default ShipmentStatistics;